import React from 'react';
interface ImageBlockProps {
  src: string;
  alt: string;
  caption: string;
}
export function ImageBlock({
  src,
  alt,
  caption
}: ImageBlockProps) {
  return <>
      <div className="mt-9 mb-0 rounded-[3px] overflow-hidden" data-id="element-16">
        <img src={src} alt={alt} className="w-full block rounded-[3px]" data-id="element-17" />
      </div>
      <p className="font-inter text-[13px] text-[#555555] italic my-2.5 mb-8 leading-[1.55]" data-id="element-18">
        {caption}
      </p>
    </>;
}